/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM, ellipsis, disable } from '@insticator/insticator-ui'; // iui-utils
import { themeV2 } from 'utils/themeV2';



/* ++++++++++ --------------- EXPORT : EMBED CARD : STYLES --------------- ++++++++++ */
export default theme => ({
	embedcard: {
		background: theme.color.light.light.swatch,
		borderRadius: pxToEm(3),
		border: `1px solid #ECF0F7`,
		boxShadow: replacePXinStringWithEM(`0 1px 1px 0 #EDF1FA`),
		minWidth: pxToEm(150), //pxToEm(310),
		position: 'relative',
		'&:hover': {
			boxShadow: theme.boxShadow.highlightCard
		},
		// grey out inactive embeds for better user visual
		'&.offline': {
			opacity: '.4'
		},
		'&.hasImage-false': {
			'& .cover': {
				backgroundColor: '#EEF3F8',
				backgroundSize: '20%',
				backgroundPosition: '50%',
				'& .overlay': {
					background: `rgba(238,243,248, .5)`
				},
				'& .details': {
					'& .name': {
						color: theme.color.supporting.dark.swatch
					}
				}
			}
		},
        '&.disabled-true':{
            extend: disable,
            filter: `grayscale(1) opacity(0.45)`
		},

		// __________..... COVER .....__________ //
		'& .cover': {
			cursor: 'pointer', // this sends user to edit mode
			// background image in component itself coming from data
			backgroundSize: 'cover',
			backgroundRepeat: 'no-repeat',
			backgroundPosition: '50% 20%',
			backgroundColor: 'transparent',
			borderRadius: 'inherit',
			borderBottomRightRadius: '0',
			borderBottomLeftRadius: '0',
			width: '100%',
			height: pxToEm(203),
			position: 'relative',
            '&.disabled-true':{
                pointerEvents: 'none',
            },

			// ..... OVERLAY ..... //
			'& .overlay': {
				borderRadius: 'inherit',
				background: "radial-gradient(ellipse at center, rgba(82,83,84,0.65) 0%, rgba(0,10,10,0.7) 100%)",
				width: '100%',
				height: '100%',
				position: 'absolute',
				top: '0',
				left: '0',
				zIndex: '1',
			},
			'& .labelcontainer': {
				display: 'flex',
				height: '100%',
				padding: pxToEm(8),
				position: 'relative',
				zIndex: '2',
				'& .labels': {
					display: 'flex',
					flexWrap: 'wrap',
					width: '100%',
					height: '43px',
					overflow: 'hidden',
					zIndex: '5',
					'-ms-overflow-style': 'none',  /* IE and Edge */
					scrollbarWidth: 'none',  /* Firefox */
					'&.labelstoggled-true': {
						height: 'fit-content',
						maxHeight: '100%',
						overflow: 'scroll'
					}
				},
				/* Hide scrollbar for Chrome, Safari and Opera */
				'& .labels::-webkit-scrollbar': {
					display: 'none'
				},
				'& .label': {
					// display: 'flex',
					// alignItems: 'center',
					background: 'rgb(250, 251, 252)',
					padding: pxToEm(4.5),
					borderRadius: pxToEm(4),
					height: 'fit-content',
					minHeight: pxToEm(20),
					fontSize: pxToEm(10),
					fontWeight: '600',
					marginRight: pxToEm(8),
					marginBottom: pxToEm(8),
					whiteSpace: 'nowrap',
					overflow: 'hidden',
					textOverflow: 'ellipsis',
					'&.toggle': {
						zIndex: '6',
						width: '16px',
						display: 'flex',
						justifyContent: 'center'
					},
					'&:last-child': {
						marginRight: '0'
					}
				},
				'& .hotspot': {
					position: 'absolute',
					top: '0',
					left: '0',
					height: '100%',
					width: '100%',
					zIndex: '4'
				}
			},

			// ..... STATUS ..... //
			'& .status': {
				pointerEvents: 'none',
				position: 'absolute',
				top: pxToEm(20),
				right: pxToEm(20),
				zIndex: '2'
			},
		},
		// ..... DETAILS ..... //
		'& .details': {
			padding: pxToEm(10),
			'& .name, .site': {
				extend: ellipsis
			},
			'& .name': {
				color: theme.color.supporting.dark.swatch,
				fontSize: pxToEm(18),
				fontWeight: '600',
				marginBottom: pxToEm(2)
			},
			'& .site': {
				color: '#96a6c5',
				fontSize: pxToEm(14)
				// width: pxToEm(380)
			}
		},
		// __________..... INFO .....__________ //
		'& .info': {
			minHeight: pxToEm(44), // needed because when we have no content the embed card height varies
			padding: pxToEm(10),
			display: 'flex',
			flexWrap: 'wrap',

			// ..... CONTAINS LABEL ..... //
			'& label': {
				color: theme.color.neutral.medium.swatch,
				fontSize: pxToEm(14),
				textAlign: 'right',
				marginRight: pxToEm(15),
				marginTop: pxToEm(1)
			},

			// ..... NO CONTENT ..... //
			'& .nocontent': {
				color: theme.color.neutral.medium.swatch,
				fontSize: pxToEm(14),
				fontStyle: 'italic',
				flex: '1',
				textAlign: 'left'
			},

			// ..... CONTENT INDICATOR ..... //
			'& .contentindicator': {
				pointerEvents: 'none',
				display: 'flex',
				flexWrap: 'wrap',
				flex: '1',
				textAlign: 'left',
				'& .contenttype.live-false': {
					display: 'none'
				},
				'& .contenttypeinner':{
					marginBottom: pxToEm(5),
					fontSize: pxToEm(14)
				}
			}
		},

		// __________..... CONTROLS .....__________ //
		'& .actions': {
			padding: replacePXinStringWithEM('10px 10px 20px'),
			display: 'flex',
			justifyContent: 'space-between',
			flexWrap: 'wrap',
			'& .status':{
				paddingRight: pxToEm(10),
				display:'flex',
				alignItems:'center',
				'& .text': {
					fontSize: pxToEm(12),
					marginLeft: pxToEm(10),
				}
			},
			'& .controls': {
				display: 'flex',
				justifyContent: 'flex-start',
				'& .link': {
					fontSize: pxToEm(18),
					marginRight: pxToEm(15),
					color: theme.color.supporting.xlight.swatch
				},
				'& .name-editlabels': {
					transform: 'rotate(135deg)'
				},
				'& .loading': {
					fontSize: pxToEm(14),
					color: theme.color.primary.medium.swatch,
					paddingTop: pxToEm(3),
					paddingBottom: pxToEm(3),
					'& .name-loader': {
						height: pxToEm(1),
						width: pxToEm(16),
						paddingBottom: pxToEm(20),
						marginRight: pxToEm(10),
						'& div': {
							borderColor: `${theme.color.primary.medium.swatch} transparent transparent transparent`,
							borderWidth: pxToEm(2),
							height: pxToEm(16),
							width: pxToEm(16)
						}
					}
				}
			},
            '&.archived': {

            }
		},
        '&.archived-true': {
		    '& .cover, .details, .info':{
		        extend: disable
            },
            '& .actions': {
		        justifyContent: 'flex-end'
            }
        },
    '& .imagesuploadstatus': {
      height: pxToEm(24),
      display: 'inline-flex',
      padding: pxToEm(14),
      fontSize: pxToEm(14),
      color: '#fff',
      alignItems: 'center',
      borderRadius: pxToEm(100),
      justifyContent: 'center',
      zIndex: 10,
      textTransform: 'capitalize',
      marginLeft: pxToEm(24),
      '& h5': { whiteSpace: 'nowrap'},
      '&.status-success': { background: themeV2.color.success.main },
      '&.status-failed': { background: themeV2.color.error.main },
      '&.status-inprogress': { background: themeV2.color.warning.main },
      '& .icon': { color: '#fff' },
      '& .name-spinner': { marginRight: pxToEm(6) }
    }
	}
});
